import { useCallback, useEffect, useState } from "react";
import Hourglass from "../images/hourglass.svg";
import MoneySafe from "../images/cofrinho-dinheiro.svg";
import PlacaSolar from "../images/placa-solar.svg";
import Arvores from "../images/arvores.svg";
import SolRaio from "../images/sol-raio.svg";
import Nuvem from "../images/nuvem.svg";
import CarroEletrico from "../images/carro-eletrico.svg";
import Dinheiro from "../images/dinheiro-mao.svg";
import { readDataStorage } from "../../../utils/storage/storage";
import { DadosPessoa, DataRes } from "../types";
import api from "../../../services/api";
import {
  Container,
  Content,
  InfoContainer,
  CardSmContainer,
  InfoColumn,
  CardLgContainer,
  DataSection,
} from "../styles";
import { Card } from "../styles";

export function InfoComponent() {
  const [data, setData] = useState<DadosPessoa>();
  const { id } = readDataStorage("block");
  const getData = useCallback(async () => {
    try {
      const response = await api.get<DataRes>(
        `/csp/usuario/consulta/link/${id}`
      );
      if (response.status === 200) {
        const apiData = response.data;

        const dadosPessoa: DadosPessoa = {
          contratante: [
            { title: "Nome do titular da conta", value: apiData.card.empresa },
            {
              title: "CPF/CNPJ",
              value:
                apiData.card.tipo === "PJ"
                  ? apiData.card.cnpj
                  : apiData.card.cpf,
            },
            {
              title: "Data de nascimento",
              value: apiData.card.data_de_nascimento_do_titular,
            },
            { title: "E-mail", value: apiData.card.email },
            {
              title: "WhatsApp",
              value: apiData.card.telefone_do_titular_da_conta,
            },
            {
              title: "Telefone",
              value: apiData.card.telefone_contato_para_liga_o,
            },
          ],
          endereco: [
            { title: "CEP", value: apiData.card.cep },
            { title: "Logradouro", value: apiData.card.rua },
            { title: "Número", value: apiData.card.n_mero },
            { title: "Complemento", value: apiData.card.complemento },
            { title: "Bairro", value: apiData.card.bairro },
            { title: "Cidade", value: apiData.card.cidade },
            { title: "Estado", value: apiData.card.estado },
          ],
          fatura: [
            { title: "Concessionária", value: apiData.card.concession_ria },
            {
              title: "Número de instalação",
              value: apiData.card.n_mero_da_instala_o_cemig_1,
            },
            {
              title: "Dia de vencimento da fatura",
              value: apiData.card.data_de_vencimento_da_fatura_cemig,
            },
            {
              title: "Forma de pagamento",
              value: apiData.card.forma_de_pagamento,
            },
          ],
          infoCalculadas: {
            mensalidade: apiData.card.mensalidade_axs,
            consumoMedio: apiData.card.m_dia_de_consumo,
            geracaoAnual: apiData.card.gera_o_anual_contratada_2,
            economiaAnual: apiData.card.economia_anual,
            emissao: apiData.infoCalculadas.carbonoEvitado,
            arvores: apiData.infoCalculadas.arvoresCultivadas,
            carroEletrico: apiData.infoCalculadas.kmCarroEletrico,
          },
        };

        setData(dadosPessoa);
      }
    } catch (error) {
      console.error("Erro ao buscar os dados:", error);
    }
  }, [id]);

  const handleFormat = (val?: number | string): string | undefined => {
    if (val !== undefined && val !== null) {
      let numberValue: number;

      if (typeof val === "string") {
        numberValue = parseFloat(val.replace(/,/g, "."));
      } else {
        numberValue = val;
      }

      if (isNaN(numberValue)) {
        return "Invalid number";
      }

      return numberValue.toLocaleString("pt-BR", {
        maximumFractionDigits: 2,
      });
    }
    return undefined;
  };

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Container>
      <Content>
        <img className="img" src={Hourglass} alt="Card bloqueado" />
        <Card size="lg" background="#6C5AF4" color="#ffffff">
          <h2 style={{ width: "100%" }}>
            A sua proposta já está em processamento e não pode ser modificada.
            <br />
            Você pode, no entanto, consultar as suas informações de proposta de
            venda e os dados associados abaixo.
          </h2>
        </Card>
        <h1 style={{ fontSize: "22px" }}>Proposta de venda</h1>
        <InfoContainer>
          <InfoColumn>
            <Card size="sm">
              <img src={MoneySafe} alt="Mensalidade" width={40} height={40} />
              <CardSmContainer>
                <h2>Mensalidade AXS</h2>

                <h1>R$ {data?.infoCalculadas.mensalidade}</h1>
              </CardSmContainer>
            </Card>
            <Card size="sm">
              <img src={PlacaSolar} alt="Mensalidade" width={40} height={40} />
              <CardSmContainer>
                <h2>Geração anual prevista</h2>

                <h1>{handleFormat(data?.infoCalculadas.geracaoAnual)} kWh</h1>
              </CardSmContainer>
            </Card>
            <Card size="sm">
              <img src={Arvores} alt="Mensalidade" width={40} height={40} />
              <CardSmContainer>
                <h2>Árvores poupadas</h2>

                <h1>{data && Math.round(data.infoCalculadas.arvores)}</h1>
              </CardSmContainer>
            </Card>
          </InfoColumn>
          <InfoColumn>
            <Card size="sm">
              <img src={SolRaio} alt="Mensalidade" width={40} height={40} />
              <CardSmContainer>
                <h2>Consumo médio previsto</h2>

                <h1>{handleFormat(data?.infoCalculadas.consumoMedio)} kWh</h1>
              </CardSmContainer>
            </Card>
            <Card size="sm">
              <img src={Nuvem} alt="Mensalidade" width={40} height={40} />
              <CardSmContainer>
                <h2>Emissão de C02 evitada</h2>

                <h1>{handleFormat(data?.infoCalculadas.emissao)} kg</h1>
              </CardSmContainer>
            </Card>
            <Card size="sm">
              <img
                src={CarroEletrico}
                alt="Mensalidade"
                width={40}
                height={40}
              />
              <CardSmContainer>
                <h2>KMs em carro elétrico</h2>

                <h1>{handleFormat(data?.infoCalculadas.carroEletrico)} km</h1>
              </CardSmContainer>
            </Card>
          </InfoColumn>
          <InfoColumn>
            <Card size="sm">
              <img src={Dinheiro} alt="Mensalidade" width={40} height={40} />
              <CardSmContainer>
                <h2>Economize anualmente até:</h2>

                <h1>R$ {data?.infoCalculadas.economiaAnual}*</h1>
                <p>
                  *A simulação considera consumidores (B1) conectados em baixa
                  tensão, ligação bifásica, e bandeira tarifária escassez
                  hídrica.
                </p>
              </CardSmContainer>
            </Card>
          </InfoColumn>
        </InfoContainer>
        <Card size="lg">
          <CardLgContainer>
            <h1>Dados do contratante</h1>
            <DataSection>
              {data &&
                data.contratante.map((item, index) => (
                  <div key={index} style={{ textAlign: "left" }}>
                    <span>{item.title}</span>
                    <h2>{item.value}</h2>
                  </div>
                ))}
            </DataSection>
            <h1>Dados de endereço</h1>
            <DataSection>
              {data &&
                data.endereco.map((item, index) => (
                  <div key={index} style={{ textAlign: "left" }}>
                    <span>{item.title}</span>
                    <h2>{item.value}</h2>
                  </div>
                ))}
            </DataSection>
            <h1>Dados da fatura</h1>
            <DataSection>
              {data &&
                data.fatura.map((item, index) => (
                  <div key={index} style={{ textAlign: "left" }}>
                    <span>{item.title}</span>
                    <h2>{item.value}</h2>
                  </div>
                ))}
            </DataSection>
          </CardLgContainer>
        </Card>
      </Content>
    </Container>
  );
}
